/**
 * @typedef TocHeading
 * @prop {string} value
 * @prop {number} depth
 * @prop {string} url
 */

/**
 * Generates an inline table of contents
 * Exclude titles matching this string (new RegExp('^(' + string + ')$', 'i')).
 * If an array is passed the array gets joined with a pipe (new RegExp('^(' + array.join('|') + ')$', 'i')).
 *
 * @param {{
 *  toc: TocHeading[],
 *  indentDepth?: number,
 *  fromHeading?: number,
 *  toHeading?: number,
 *  asDisclosure?: boolean,
 *  exclude?: string|string[]
 * }} props
 *
 */
function TOCInline({ toc, fromHeading = 1, toHeading = 6, asDisclosure = true, exclude = '' }) {
  const re = Array.isArray(exclude)
    ? new RegExp(`^(${exclude.join('|')})$`, 'i')
    : new RegExp(`^(${exclude})$`, 'i');

  const filteredToc = toc.filter(
    (heading) =>
      heading.depth >= fromHeading && heading.depth <= toHeading && !re.test(heading.value),
  );

  function getHeadingMargin(heading) {
    if (heading.depth < fromHeading || heading.depth.toHeading) {
      return '';
    }
    if (heading.depth >= 6) {
      return 'ml-20';
    }
    if (heading.depth >= 5) {
      return 'ml-15';
    }
    if (heading.depth == 4) {
      return 'ml-10';
    }
    if (heading.depth == 3) {
      return 'ml-5';
    }
    return '';
  }

  const tocList = (
    <ul>
      {filteredToc.map((heading) => (
        <li key={heading.value} className={getHeadingMargin(heading)}>
          <a href={heading.url} className="hover:font-bold hover:text-lg hover:no-underline">
            {heading.value}
          </a>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {asDisclosure ? (
        <details open>
          <summary className="pt-2 pb-2 ml-6 text-xl font-bold">Table of Contents</summary>
          <div className="ml-6">{tocList}</div>
        </details>
      ) : (
        tocList
      )}
    </>
  );
}

export default TOCInline;
